import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

const Link = ({ children, to, ...restProps }) => {
  if (to.startsWith('http')) {
    // If the url starts with `http` we use an `<a>` element for external routing
    return (
      <a href={to} {...restProps}>
        {children}
      </a>
    );
  }

  let prefix = '';
  // If the route is internal and the url is not prefixed with a slash, we add it here
  if (!to.startsWith('/')) prefix = '/';

  return (
    <RouterLink to={`${prefix}${to}`} {...restProps}>
      {children}
    </RouterLink>
  );
};

Link.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  to: PropTypes.string,
};

export default Link;
